import { render, staticRenderFns } from "./DeckSelect.vue?vue&type=template&id=56aa5cd8&"
import script from "./DeckSelect.vue?vue&type=script&lang=js&"
export * from "./DeckSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports